import React from 'react';

import { Box, Typography } from '@mui/material';

import { translate } from '@/data/fixture-transalations';

import WrapperBarComponent from '../charts/BarComponent/wrapper-bar-component';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const MinutesActionsGraphicalPlayerComponent = ({ partidos }) => {
    const jornadas = partidos.map((item) => translate(item?.round, true));
    const minutos = partidos.map((item) => Number(item?.minutes ?? 0));

    const azul = 'rgba(25, 118, 210, 0.7)';
    const verde = 'rgba(75, 192, 75, 0.7)';
    const naranja = 'rgba(255, 165, 0, 0.7)'; // Naranja
    const rojo = 'rgba(255, 99, 132, 0.7)'; // Rojo

    // Función para determinar el color de cada barra
    const getBarColor = (minutos) => {
        if (minutos >= 90) return azul; // Azul
        if (minutos >= 60) return verde; // Verde
        if (minutos >= 45) return naranja; // Naranja
        return rojo; // Rojo
    };

    const colors = [
        { key: '90+ mins', value: azul },
        { key: '60+ -90', value: verde },
        { key: '45+ -60', value: naranja },
        { key: '45- mins', value: rojo },
    ];

    const backgroundColors = minutos.map(getBarColor);

    const chartData = {
        labels: jornadas,
        datasets: [
            {
                label: 'Minutos disputados',
                data: minutos,
                backgroundColor: backgroundColors, // Aplica colores dinámicos
                borderColor: 'rgba(0, 0, 0, 0.3)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
                text: 'Minutos disputados por jornada',
            },
        },
    };

    return (
        <CustomSectionWrapper color="accent3" title="Minutos disputados por jornada">
            <WrapperBarComponent text={''} data={chartData} options={options} />

            <Box display={'flex'} justifyContent={'center'} mt={1} gap={1}>
                {colors.map((item, index) => (
                    <Typography
                        key={index}
                        fontSize={12}
                        backgroundColor={item.value}
                        color={'#fff'}
                        py={0.5}
                        width={55}
                        textAlign={'center'}
                        borderRadius={1}
                        variant="h3"
                    >
                        {item.key}
                    </Typography>
                ))}
            </Box>
        </CustomSectionWrapper>
    );
};

export default MinutesActionsGraphicalPlayerComponent;
